var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['amount', _vm.size]},[(!_vm.prefix)?_vm._t("prefix"):_c('span',[_vm._v(_vm._s(_vm.prefix))]),_vm._v(" "+_vm._s(_vm.value)+" "),_vm._t("suffix")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }